import { useState, useEffect } from "react";

//MUI
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import moment from "moment";
import "./ModalSaida.scss";

function ModalVerSaida({
  openModalVerSaida,
  handleCloseModalVerSaida,
  dadosModalVerSaida,
}) {
  const [openModal, setOpenModal] = useState(openModalVerSaida);
  useEffect(() => {
    setOpenModal(openModalVerSaida);
  }, [openModalVerSaida]);

  return (
    <>
      <Modal
        open={openModal}
        onClose={handleCloseModalVerSaida}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          className="fluxo-atendimento__modal__box adicionar-despesa__modal"
          id="modal__adicionar-despesa"
        >
          <h1 className="fluxo-atendimento__modal__titulo">Ver saída</h1>
          <div className="adicionar-despesa__modal__container">
            <div className="customInputContainer adicionar-despesa__modal__container--span2">
              <input
                type="text"
                defaultValue={dadosModalVerSaida.descricao}
                className="customInput inputNumber"
                id="descricao"
                style={{ pointerEvents: "none", color: "#88959e" }}
              />
              <label className="customInputLabel" htmlFor="descricao">
                Descricao
              </label>
            </div>

            <div className="customInputContainer adicionar-despesa__modal__container--span1">
              <input
                type="text"
                defaultValue={dadosModalVerSaida.valor}
                className="customInput inputNumber"
                id="valor"
                style={{ pointerEvents: "none", color: "#88959e" }}
              />
              <label className="customInputLabel" htmlFor="valor">
                Valor
              </label>
            </div>

            <LocalizationProvider
              dateAdapter={AdapterMoment}
              className="adicionar-despesa__modal__container--span1"
            >
              <DesktopDatePicker
                className="valorDataCaixa__fields--field muiDatePicker"
                label="Data de vencimento*"
                inputFormat="DD-MM-YYYY"
                value={moment(dadosModalVerSaida.dataLimitePagamento)}
                renderInput={(params) => <TextField {...params} />}
                disabled
                onChange={() => {}}
              />
            </LocalizationProvider>

            {dadosModalVerSaida.fornecedor && (
              <div className="customInputContainer adicionar-despesa__modal__container--span2">
                <input
                  type="text"
                  defaultValue={dadosModalVerSaida.fornecedor?.nome || ""}
                  className="customInput inputNumber"
                  id="fornecedor"
                  style={{ pointerEvents: "none", color: "#88959e" }}
                />
                <label className="customInputLabel" htmlFor="fornecedor">
                  Fornecedor
                </label>
              </div>
            )}

            {dadosModalVerSaida.funcionario && (
              <div className="customInputContainer adicionar-despesa__modal__container--span2">
                <input
                  type="text"
                  defaultValue={dadosModalVerSaida.funcionario.nome || ""}
                  className="customInput inputNumber"
                  id="funcionario"
                  style={{ pointerEvents: "none", color: "#88959e" }}
                />
                <label className="customInputLabel" htmlFor="funcionario">
                  Funcionário
                </label>
              </div>
            )}

            {dadosModalVerSaida.funcionarioUser && (
              <div className="customInputContainer adicionar-despesa__modal__container--span2">
                <input
                  type="text"
                  defaultValue={dadosModalVerSaida.funcionarioUser.name || ""}
                  className="customInput inputNumber"
                  id="funcionarioUser"
                  style={{ pointerEvents: "none", color: "#88959e" }}
                />
                <label className="customInputLabel" htmlFor="funcionarioUser">
                  Funcionário
                </label>
              </div>
            )}

            {dadosModalVerSaida.cliente && (
              <div className="customInputContainer adicionar-despesa__modal__container--span2">
                <input
                  type="text"
                  defaultValue={
                    dadosModalVerSaida.cliente.nome || "Sem cliente"
                  }
                  className="customInput inputNumber"
                  id="cliente"
                  style={{ pointerEvents: "none", color: "#88959e" }}
                />
                <label className="customInputLabel" htmlFor="cliente">
                  Cliente
                </label>
              </div>
            )}

            <div className="customInputContainer adicionar-despesa__modal__container--span2">
              <input
                type="text"
                defaultValue={
                  dadosModalVerSaida.categoria.categoria
                    ? dadosModalVerSaida.categoria.categoria
                    : dadosModalVerSaida.categoria.value
                }
                className="customInput inputNumber"
                id="categoria"
                style={{ pointerEvents: "none", color: "#88959e" }}
              />
              <label className="customInputLabel" htmlFor="categoria">
                Categoria
              </label>
            </div>

            <div className="customInputContainer adicionar-despesa__modal__container--span1">
              <input
                type="text"
                defaultValue={
                  dadosModalVerSaida.caixa.caixa
                    ? dadosModalVerSaida.caixa.caixa
                    : dadosModalVerSaida.caixa.value
                }
                className="customInput inputNumber"
                id="caixa"
                style={{ pointerEvents: "none", color: "#88959e" }}
              />
              <label className="customInputLabel" htmlFor="caixa">
                Caixa
              </label>
            </div>

            {dadosModalVerSaida.pagaPor?.name && (
              <div className="customInputContainer adicionar-despesa__modal__container--span1">
                <input
                  type="text"
                  defaultValue={
                    dadosModalVerSaida.pagaPor?.name
                      ? dadosModalVerSaida.pagaPor.name
                      : ""
                  }
                  className="customInput inputNumber"
                  id="pagaPor"
                  style={{ pointerEvents: "none", color: "#88959e" }}
                />
                <label className="customInputLabel" htmlFor="pagaPor">
                  Paga Por
                </label>
              </div>
            )}

            {dadosModalVerSaida.observacoes && (
              <textarea
                cols="30"
                rows="7"
                defaultValue={
                  dadosModalVerSaida.observacoes
                    ? dadosModalVerSaida.observacoes
                    : ""
                }
                className="adicionar-despesa__modal__container__textarea"
                disabled
                style={{ color: "#88959e" }}
              ></textarea>
            )}
          </div>

          {dadosModalVerSaida.despesaPaga && (
            <div
              className="adicionar-despesa__modal__pagamento"
              style={{ marginTop: 25, marginBottom: 25 }}
            >
              <LocalizationProvider
                dateAdapter={AdapterMoment}
                className="adicionar-despesa__modal__container--span1"
              >
                <DesktopDatePicker
                  className="valorDataCaixa__fields--field muiDatePicker"
                  label="Data de pagamento*"
                  inputFormat="DD-MM-YYYY"
                  value={dadosModalVerSaida.dataPagamento}
                  renderInput={(params) => <TextField {...params} />}
                  disabled
                  onChange={() => {}}
                />
              </LocalizationProvider>

              {/* Este campo estava escrito duas vezes, igual — apareciam dois
                  «Metodo do Pagamento» um a seguir ao outro. */}
              <div className="customInputContainer adicionar-despesa__modal__container--span1">
                <input
                  type="text"
                  defaultValue={dadosModalVerSaida.metodoPagamento}
                  className="customInput inputNumber"
                  id="metodoPagamento"
                  style={{ pointerEvents: "none", color: "#88959e" }}
                />
                <label className="customInputLabel" htmlFor="metodoPagamento">
                  Metodo do Pagamento
                </label>
              </div>

              {(dadosModalVerSaida.metodoPagamento === "Cheque" ||
                dadosModalVerSaida.metodoPagamento === "Cheque Visado") && (
                <>
                  <div className="customInputContainer adicionar-despesa__modal__container--span2">
                    <input
                      type="text"
                      defaultValue={dadosModalVerSaida.banco || ""}
                      className="customInput inputNumber"
                      id="banco"
                      style={{ pointerEvents: "none", color: "#88959e" }}
                      readOnly
                    />
                    <label className="customInputLabel" htmlFor="banco">
                      Banco
                    </label>
                  </div>

                  <div className="customInputContainer adicionar-despesa__modal__container--span2">
                    <input
                      type="text"
                      defaultValue={dadosModalVerSaida.nrContaCliente || ""}
                      className="customInput inputNumber"
                      id="nrContaCliente"
                      style={{ pointerEvents: "none", color: "#88959e" }}
                      readOnly
                    />
                    <label
                      className="customInputLabel"
                      htmlFor="nrContaCliente"
                    >
                      Nº Conta Cliente
                    </label>
                  </div>

                  <div className="customInputContainer adicionar-despesa__modal__container--span1">
                    <input
                      type="text"
                      defaultValue={dadosModalVerSaida.nrCheque || ""}
                      className="customInput inputNumber"
                      id="nrCheque"
                      style={{ pointerEvents: "none", color: "#88959e" }}
                      readOnly
                    />
                    <label className="customInputLabel" htmlFor="nrCheque">
                      Nº Cheque
                    </label>
                  </div>

                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DesktopDatePicker
                      className="valorDataCaixa__fields--field muiDatePicker"
                      label="Data do Cheque"
                      inputFormat="DD-MM-YYYY"
                      value={
                        dadosModalVerSaida.dataCheque
                          ? moment(dadosModalVerSaida.dataCheque)
                          : null
                      }
                      renderInput={(params) => <TextField {...params} />}
                      disabled
                      readOnly
                      onChange={() => {}}
                    />
                  </LocalizationProvider>
                </>
              )}
            </div>
          )}

          {dadosModalVerSaida.comprovativo && (
            <div className="verComprovativoContainer">
              <span>Comprovativo:</span>
              <a
                href={`${process.env.REACT_APP_BACKEND_LINK}/${dadosModalVerSaida.comprovativo.ficheiro}`}
                download
                target="_blank"
                rel="noreferrer"
              >
                {dadosModalVerSaida.comprovativo.descricao}
              </a>
            </div>
          )}

          <div className="fluxo-atendimento__modal__bottom_btns">
            <span
              className="cancel-btn"
              onClick={handleCloseModalVerSaida}
              style={{ display: "block" }}
            >
              Fechar
            </span>
          </div>
        </Box>
      </Modal>

    </>
  );
}

export default ModalVerSaida;
